import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './HeroCarousel.css';

const HeroCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isPlaying, setIsPlaying] = useState(true);

    const slides = [
        {
            id: 1,
            title: "See Your Financial Reality Clearly",
            subtitle: "Plan Your Life Confidently",
            description: "Most financial problems don't come from low income. They come from lack of clarity.",
            cta: "Start Your Financial Diagnosis",
            link: "/begin-with-clarity",

        },
        {
            id: 2,
            title: "You Deserve Financial Advice",
            subtitle: "From a True Partner",
            description: "Yatharth advisory services are here to help at every step—from your first investment through retirement.",
            cta: "Start Your Financial Diagnosis",
            link: "/begin-with-clarity",

        },
        {
            id: 3,
            title: "Our Economic and Market Outlook",
            subtitle: "Is Now Available",
            description: "Get insights into current market trends and economic forecasts to make informed financial decisions.",
            cta: "Start Your Financial Diagnosis",
            link: "/begin-with-clarity",

        }
    ];

    const nextSlide = useCallback(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, [slides.length]);

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const togglePlayPause = () => {
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        if (isPlaying) {
            const interval = setInterval(() => {
                nextSlide();
            }, 5000); // Change slide every 5 seconds

            return () => clearInterval(interval);
        }
    }, [isPlaying, nextSlide]);

    return (
        <div className="hero-carousel">
            <div className="carousel-container">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="carousel-video-background"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 0

                    }}
                >
                    <source src="/bannervd.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div
                    className="carousel-overlay"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 100%)', // Black linear gradient overlay
                        zIndex: 1
                    }}
                ></div>

                {slides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                        style={{
                            // Removed backgroundImage style as it's replaced by video
                            zIndex: 2 // Ensure content is above video and overlay
                        }}
                    >
                        <div className="carousel-content">
                            <div className="carousel-text">
                                <h1 className="carousel-title">{slide.title}</h1>
                                <h2 className="carousel-subtitle">{slide.subtitle}</h2>
                                <p className="carousel-description">{slide.description}</p>
                                <Link to={slide.link} className="carousel-cta">
                                    {slide.cta} →
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Navigation Controls */}
            <div className="carousel-controls" style={{ zIndex: 10 }}>
                {/* Pause/Play Button */}
                {/* <button
                    className="carousel-play-pause"
                    onClick={togglePlayPause}
                    aria-label={isPlaying ? "Pause" : "Play"}
                >
                    {isPlaying ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <rect x="6" y="4" width="4" height="16" />
                            <rect x="14" y="4" width="4" height="16" />
                        </svg>
                    ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5v14l11-7z" />
                        </svg>
                    )}
                </button> */}

                {/* Previous Button */}
                {/* <button
                    className="carousel-nav carousel-prev"
                    onClick={prevSlide}
                    aria-label="Previous slide"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M15 18l-6-6 6-6" />
                    </svg>
                </button> */}

                {/* Pagination Dots */}
                <div className="carousel-pagination">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>

                {/* Next Button */}
                {/* <button
                    className="carousel-nav carousel-next"
                    onClick={nextSlide}
                    aria-label="Next slide"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 18l6-6-6-6" />
                    </svg>
                </button> */}
            </div>
        </div>
    );
};

export default HeroCarousel;
